import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// Modules
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import * as i0 from "@angular/core";
export class RadioButtonGroupModule {
}
RadioButtonGroupModule.ɵfac = function RadioButtonGroupModule_Factory(t) { return new (t || RadioButtonGroupModule)(); };
RadioButtonGroupModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RadioButtonGroupModule });
RadioButtonGroupModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, DisabledModule, FormsModule, HelpModalModule] });
